import React, { useState, useEffect } from 'react'
import { Box, Grid, TextField, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';




const NoticeForm = ({ notice, formik }) => {

  const [wrStartDt, setWrStartDt] = useState(null);
  const [wrEndDt, setWrEndDt] = useState(null);




  useEffect(() => {
    if (notice !== null) {
      if (notice?.wrStartDt) setWrStartDt(notice?.wrStartDt);
      if (notice?.wrEndDt) setWrEndDt(notice?.wrEndDt);

    }
  }, [notice]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue, true);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}

      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            required={true}
            variant="outlined"
            fullWidth
            id="wrTitle"
            name="wrTitle"
            label="제목"
            value={formik.values.wrTitle}
            onChange={formik.handleChange}
            error={formik.touched.wrTitle && Boolean(formik.errors.wrTitle)}
            helperText={formik.touched.wrTitle && formik.errors.wrTitle}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            required={true}
            variant="outlined"
            fullWidth
            multiline
            rows={5}
            id="wrContent"
            name="wrContent"
            label="내용"
            value={formik.values.wrContent}
            onChange={formik.handleChange}
            error={
              formik.touched.wrContent && Boolean(formik.errors.wrContent)
            }
            helperText={formik.touched.wrContent && formik.errors.wrContent}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={3}>
          <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
            <DatePicker
              label="게시 시작일"
              inputFormat={'yyyy-MM-dd'}
              mask={'____-__-__'}
              id="wrStartDt"
              name="wrStartDt"
              value={wrStartDt}
              onChange={(newValue) => {
                setWrStartDt(newValue);
                onChangeDate(newValue, 'wrStartDt');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  required={false}
                  fullWidth
                  error={
                    formik.touched.wrStartDt && Boolean(formik.errors.wrStartDt)
                  }
                  helperText={
                    formik.touched.wrStartDt && formik.errors.wrStartDt
                  }
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={3}>
          <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
            <DatePicker
              label="게시 종료일"
              inputFormat={'yyyy-MM-dd'}
              mask={'____-__-__'}
              id="reqEndDt"
              name="reqEndDt"
              value={wrEndDt}
              onChange={(newValue) => {
                setWrEndDt(newValue);
                onChangeDate(newValue, 'wrEndDt');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  required={false}
                  fullWidth
                  error={
                    formik.touched.wrEndDt && Boolean(formik.errors.wrEndDt)
                  }
                  helperText={formik.touched.wrEndDt && formik.errors.wrEndDt}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <FormControlLabel
              id="useYn"
              name="useYn"
              label="사용"
              control={
                <Checkbox
                  checked={formik.values.useYn}
                  onChange={formik.handleChange}
                />
              }
            />
          </FormGroup>
        </Grid>
      </Grid>
    </Box>
  )
}

export default NoticeForm